<template>
    <div class="element" @click="selectElement(id, name, imgSrc)"
         :ref="name">

        <div class="img-container">
            <img :src="'data:image/png;base64, ' + imgSrc" alt="material_image">
        </div>
        <div class="name-container">
            <span class="text">{{translate(name)}}</span>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ThirdStepElement",
        props: ["id", 'name', 'imgSrc'],
        methods: {

            changeStep(step) {

                this.$store.commit({
                    type: 'changeActiveConfigurationStep',
                    step: step
                })

            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;

            },

            selectElement(id, name, imgSrc) {

                this.$store.commit({
                    type: 'selectThirdStepElement',
                    id: id,
                    name: name,
                    imgSrc: imgSrc,
                });

                this.changeStep(4);
            },

        },
    }
</script>